import React from "react";
import { MessageCircle } from "lucide-react";

const PHONE = "919091100200"; // wa.me format

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] group"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-whatsapp animate-whatsapp-pulse" />
        <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-whatsapp flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] transition-all duration-300 group-hover:scale-110 group-hover:rotate-[8deg]">
          {/* WhatsApp glyph */}
          <svg viewBox="0 0 32 32" className="w-7 h-7 md:w-8 md:h-8 fill-white" aria-hidden="true">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.084 0-.149-.025-.198-.046-.628-.292-3.106-1.387-4.557-3.36-.097-.13-.16-.247-.198-.345-.07-.18-.082-.298.043-.428.124-.13.247-.247.371-.371.124-.124.198-.247.297-.395.099-.148.05-.296-.025-.42-.074-.124-.677-1.622-.943-2.213-.272-.6-.541-.495-.738-.495-.198 0-.421-.05-.643-.05-.222 0-.591.074-.911.395-.32.32-1.214 1.184-1.214 2.882s1.243 3.34 1.416 3.563c.173.223 2.4 3.85 5.93 5.392 3.529 1.541 3.529 1.028 4.166.964.638-.064 2.064-.841 2.357-1.65.293-.81.293-1.5.222-1.65-.07-.149-.247-.247-.519-.347-.272-.099-1.615-.815-1.867-.908-.252-.092-.434-.143-.617.149zM16.001 5.333C10.118 5.333 5.334 10.117 5.334 16c0 1.876.493 3.71 1.43 5.32L5.5 26.5l5.337-1.226A10.626 10.626 0 0 0 16 26.667c5.882 0 10.667-4.785 10.667-10.667S21.881 5.333 16 5.333zm0 19.4a8.73 8.73 0 0 1-4.43-1.207l-.317-.188-3.27.752.789-3.111-.199-.328a8.73 8.73 0 1 1 7.426 4.082z" />
          </svg>
        </div>
        <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 px-3 py-2 rounded-xl bg-navy-deep text-white text-xs font-medium whitespace-nowrap shadow-xl opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
          Chat with us · Replies in 5 min
        </div>
      </div>
    </a>
  );
}
